module.exports = __webpack_public_path__ + "img/Blog-Image@2x.22a84dec.png";